import React from 'react';
import styled from 'styled-components';
import TierActiveFilter from './TierActiveFilter';
import { RFC } from 'state/StateTypes';
import BaseButton from './BaseButton';
import useViewport from 'hooks/useViewport';
import { Link } from '@reach/router';
import { StateItems } from 'state/assets/AssetTypes';

interface Props {
   title: StateItems;
}

const ListHeader: RFC<Props> = ({ title }) => {
   const [{ width: windowWidth }] = useViewport();
   return (
      <Container>
         <FlexWrapper>
            <ListTitle>{title.toLocaleUpperCase()}</ListTitle>
            <DropDownContainer>
               <TierActiveFilter content="Tier" title={title} />
               <TierActiveFilter content="Active" title={title} />
            </DropDownContainer>
            {windowWidth < 593 && (
               <Link to={`${window.location.pathname}/create`}>
                  <CreateButton>CREATE</CreateButton>
               </Link>
            )}
         </FlexWrapper>
         {windowWidth >= 594 && (
            <Link to={`${window.location.pathname}/create`}>
               <CreateButton>CREATE</CreateButton>
            </Link>
         )}
      </Container>
   );
};

export default ListHeader;

const Container = styled.div`
   display: flex;
   flex-wrap: wrap;
   justify-content: space-between;
   flex-direction: row nowrap;
   align-items: center;
`;

const ListTitle = styled.h2`
   font-weight: 700;
   font-size: 2em;
   color: ${({ theme }) => theme.primaryBlueDark};
   padding: 5px;
   margin-right: 5px;
`;
const DropDownContainer = styled.div`
   display: flex;
   justify-content: flex-start;
   flex-direction: row nowrap;
   align-items: center;
`;

const CreateButton = styled(BaseButton)`
   width: auto;
   padding: 10px 15px;
   margin: unset;
   @media only screen and (max-width: 613px) {
      margin-left: 5px;
   }
`;

const FlexWrapper = styled.div`
   display: flex;
   flex-flow: row wrap;
   justify-content: center;
   justify-self: flex-start;

   @media only screen and (max-width: 415px) {
      margin-bottom: 7px;
   }
`;
